import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';

import { getCompany, getSubcompany } from 'auth/selectors';
import {
  getEmployeesAssetsReportPagination,
  getEmployeesAssetsReportFilters,
  getEmployeesAssetsReportNeedFetch,
} from 'reports/selectors';

import {
  getEmployeesAssetsReport,
  setEmployeesAssetsReportPagination as setPagination,
  setEmployeesAssetsReportFilters as setFilters,
  resetEmployeesAssetsReport as reset,
} from 'reports/actions';

import { valueFromEvent } from 'lib/util';

class EmployeesAssetsReportHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  fetch = (filters, pagination) => {
    console.log(pagination.limit, pagination.page, pagination.orderBy, pagination.order);
    this.props.fetch(
      this.props.company.id,
      this.props.subcompany.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );
  };

  fetchDebounced = debounce(this.fetch, 300);

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleFiltersSubmit = () => this.fetch(this.props.pagination, this.props.filters);

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  componentWillMount = () => this.fetch(this.props.filters, this.props.pagination);

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.needFetch && !isEqual(nextProps.pagination, this.props.pagination)) {
      this.fetch(nextProps.filters, nextProps.pagination);
    } else if (nextProps.needFetch && !isEqual(nextProps.filters, this.props.filters)) {
      this.fetchDebounced(nextProps.filters, nextProps.pagination);
    }
  };

  render = () =>
    this.props.render({
      handleFiltersChange: this.handleFiltersChange,
      handleFiltersSubmit: this.handleFiltersSubmit,
      handleLimitChange: this.handleLimitChange,
      handleOrderChange: this.handleOrderChange,
      handlePageChange: this.handlePageChange,
    });
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getEmployeesAssetsReportPagination(state),
  filters: getEmployeesAssetsReportFilters(state),
  needFetch: getEmployeesAssetsReportNeedFetch(state),
});

const mapDispatchToProps = { fetch: getEmployeesAssetsReport, setPagination, setFilters, reset };

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesAssetsReportHandlers);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/EmployeesAssetsReportHandlers.js